import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../../t2c-fe/utils';

interface Payload {
  prompt: string;
  model: string;
}

const enchancePrompt = async (payload: Payload): Promise<string> => {
  const res = await axiosInstance.post('/api/script/enhance-prompt', payload);
  return res.data;
};
export const useEnhancePrompt = () => {
  return useMutation(enchancePrompt, { onSuccess: (data) => data });
};
